import React from 'react';

const HomeIcon = <svg version="1.2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><g><defs> </defs> <path fillRule="evenodd" clipRule="evenodd" d="M12,0L0,12l2,2L12,4l10,10l2-2L12,0z M5,14v10h14V14l-7-7L5,14z" style={{ fill: 'white' }} vectorEffect="non-scaling-stroke" /> </g></svg>;

export default HomeIcon;